import React from "react";
import { Box, Grid, Chip } from "@mui/material";
import {
  InfoOutlined,
  LocationOnOutlined,
  DateRangeOutlined,
  LocationSearchingOutlined,
  DirectionsCarFilledOutlined,
} from "@mui/icons-material";

import { useRealTimeTrackingDetailContext } from "contexts/RealTimeTrackingDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { localizeDateTimeShort } from "utils/dateFormats";

const statusStyles = {
  "On The Way": {
    backgroundColor: "#D4EDDA",
    textColor: "#155724",
  },
  Delivered: {
    backgroundColor: "#C3E6CB",
    textColor: "#155724",
  },
  Pending: {
    backgroundColor: "#FFF3CD",
    textColor: "#856404",
  },
  Canceled: {
    backgroundColor: "#FADBD8",
    textColor: "#C0392B",
  },
  default: {
    backgroundColor: "#E9ECEF",
    textColor: "#6C757D",
  },
};

const getStatusStyle = (status) => statusStyles[status] || statusStyles.default;

const RealTimeTrackingBasicDetail = () => {
  const { trackingDetail, loadingTracking } = useRealTimeTrackingDetailContext();
console.log(trackingDetail, "");
  return !loadingTracking ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        
      <Grid item xs={4}>
          <InformationTile
            icon={() => <LocationSearchingOutlined color="primary" />}
            title="Tracking ID"
            subtitle= {trackingDetail?.trackingId}
          />
        </Grid>
        <Grid item xs={4}>
          <InformationTile
            icon={() => <DirectionsCarFilledOutlined color="primary" />}
            title="Vehicle ID"
            subtitle={
              trackingDetail?.vehicle_id && typeof trackingDetail.vehicle_id === "object"
              ? trackingDetail.vehicle_id.vehicle_id
              : trackingDetail?.vehicle_id 
                     }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <DateRangeOutlined color="primary" />}
            title="Timestamp"
            subtitle={
              trackingDetail?.timestamp
                ? localizeDateTimeShort(trackingDetail.timestamp)
                : "N/A"
            }
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <LocationOnOutlined color="primary" />}
            title="Current Location"
            subtitle={`Lat: ${trackingDetail?.location?.lat || "N/A"}, Lon: ${
              trackingDetail?.location?.lon || "N/A"
            }`}
          />
        </Grid>

        <Grid item xs={4}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Status"
            subtitle={
              <Box display="flex" flexDirection="column" alignItems="start" mt={1}>
                <Chip
                  label={trackingDetail?.status || "Unknown"}
                  style={{
                    backgroundColor: getStatusStyle(trackingDetail?.status).backgroundColor,
                    color: getStatusStyle(trackingDetail?.status).textColor,
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    fontSize: "0.7rem",
                    height: "20px",
                    padding: "0 6px",
                    borderRadius: "12px",
                    marginTop: "4px",
                    width: "auto",
                  }}
                />
              </Box>
            }
          />
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default RealTimeTrackingBasicDetail;
